import React from "react";
import { Image, ImageProps } from "react-bootstrap";
import ImageHyperCoin from "../../images/hyper-coin.svg";

export default function HyperCoin({ ...props }: Omit<ImageProps, "src" | "alt">) {
  return (
    <Image src={ImageHyperCoin} alt="Hyper coin" {...props} />
  );
}
